<script>
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'UserDropdown',
  methods: {
    handleSudoLogout() {
      this.$http
        .delete('/admin/users/sudo')
        .then(() => (location.href = '/admin')) // trigger reload
        .catch(err => {
          this.$notify({
            type: 'error',
            title: this.$t('Error'),
            message: getErrorMessage(err.response.data.code)
          });
        });
    }
  }
};
</script>

<template>
  <el-dropdown ref="dropdown" trigger="click">
    <el-button type="text">
      <img
        :src="$store.state.user.avatar ? $store.state.user.avatar : require('@/assets/user-dark.svg')"
        :alt="$store.state.user.name"
        :class="{
          avatar: true,
          'is-sudo': $store.state.metadata.isSudo
        }"
      />
      <i class="el-icon-fa-angle-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-if="$store.state.user.isSuperuser" @click.native="$router.push({ name: 'Admin' })">
        Admin Panel
      </el-dropdown-item>
      <el-dropdown-item @click.native="$router.push({ name: 'EditProfile' })">
        {{ $t('Edit Profile') }}
      </el-dropdown-item>
      <el-dropdown-item v-if="$store.state.metadata.isSudo" divided @click.native="handleSudoLogout">
        Exit Sudo Mode
      </el-dropdown-item>
      <el-dropdown-item v-else divided @click.native="$router.push({ name: 'Logout' })">
        {{ $t('Logout') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($--color-primary, 0.5);
  }
  70% {
    box-shadow: 0 0 0 0.5rem rgba($--color-primary, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($--color-primary, 0);
  }
}

.el-button {
  padding-left: 0.25rem;
  padding-right: 0.25rem;

  &:focus {
    filter: brightness(115%);
  }
}

.el-icon-fa-angle-down {
  color: $--color-gray-60;
}

.avatar {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  vertical-align: middle;

  &.is-sudo {
    animation: pulse 1.5s infinite;
  }

  @include breakpoint('sm-and-down') {
    width: 1.6rem;
    height: 1.6rem;
  }
}
</style>
